import { render } from "./AutonomieHandicapResume.vue?vue&type=template&id=6aa09dbe"
import script from "./AutonomieHandicapResume.vue?vue&type=script&lang=js"
export * from "./AutonomieHandicapResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__